import React from 'react'
import styles from "../../../Styles/ComponentStyles/MainPages/dashboard.module.scss"
import globalStyles from '../../../Styles/global.module.scss'

import Grid from '@mui/material/Grid2';
import { Avatar, Divider, Typography } from '@mui/material';
import { capitalize, useIsBelow450 } from '../../../Utils/Constant/Constant';


const AcrylicTeamProfilelist = (props: any) => {

    const { acrylicTeamListData } = props
    const isBelow450 = useIsBelow450()

    const formatPhoneNumber = (phone: string) => {
        const cleaned = phone.replace(/\D/g, '');
        if (cleaned.length === 10) {
            return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
        }
        return phone;
    };


    return (
        <>
            <Grid size={{ xs: 12 }} className={`${styles.dsGlobalFeatureCardStyle} ${styles.dsGlobalCardStyles}`} >
                <Grid container>
                    <Grid size={{ xs: 12 }} sx={{ mb: "20px" }}>
                        <Typography component={"span"} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV24}`}>Your Acrylic Team</Typography>
                    </Grid>

                    <Grid
                        size={{ xs: 12 }}
                        sx={{
                            maxHeight: acrylicTeamListData?.length ? "50vh" : "50px",
                            height: acrylicTeamListData?.length ? "fit-content" : "50px",
                            overflow: 'auto',
                            paddingRight: "5px"
                        }}
                    >
                        <Grid container>
                            {acrylicTeamListData && acrylicTeamListData.length > 0 ? (
                                acrylicTeamListData?.map((ele: any, index: number) => {
                                    const isLastItem = index == acrylicTeamListData.length - 1;
                                    return (
                                        <Grid key={ele?.id || index} size={{ xs: 12 }}>
                                            <Grid container>
                                                {!isBelow450 ?
                                                    (
                                                        <>
                                                            <Grid size={{ xs: 12 }}>
                                                                <Grid container sx={{ justifyContent: 'space-between' }}>
                                                                    <Grid className={`${styles.acrylicTeamProfileItem}`} sx={{ display: 'flex', alignItems: 'center' }}>
                                                                        <Avatar
                                                                            className={`${styles.acrylicteamProfileAvtar}`}
                                                                            src={ele?.image || ""}
                                                                        />
                                                                    </Grid>
                                                                    <Grid className={`${styles.acrylicTeamProfileTextItem}`}>
                                                                        <Grid container>
                                                                            <Grid size={{ xs: 12 }} sx={{ m: "3px 0px" }}>
                                                                                <Typography component='span' sx={{ display: "inline-flex !important" }} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                                                    {`${capitalize(ele?.firstName) || ""} ${capitalize(ele?.lastName) || ""}`}
                                                                                </Typography>
                                                                            </Grid>
                                                                            <Grid size={{ xs: 12 }} sx={{ m: "3px 0px" }}>
                                                                                <Typography
                                                                                    component='span'
                                                                                    className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV12} ${styles.memberTitleText}`}
                                                                                >
                                                                                    {ele?.memberTitle || ""}
                                                                                </Typography>
                                                                            </Grid>
                                                                            <Grid size={{ xs: 12 }} sx={{ m: "3px 0px 0px" }}>
                                                                                <Typography component='span' sx={{ display: "inline-flex !important" }} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV13}`}>
                                                                                    {ele?.memberEmail || ""}
                                                                                </Typography>
                                                                            </Grid>
                                                                            <Grid size={{ xs: 12 }} sx={{ m: "3px 0px" }}>
                                                                                <Typography component='span' sx={{ display: "inline-flex !important" }} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV13}`}>
                                                                                    {ele?.memberPhone ? formatPhoneNumber(ele.memberPhone) : ""}
                                                                                </Typography>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Grid size={{ xs: 12 }}>
                                                                <Grid container sx={{ justifyContent: 'space-between' }}>
                                                                    <Grid size={{ xs: 12 }}>
                                                                        <Grid container className={`${styles.acrylicTeamContainer}`}>
                                                                            <Grid className={`${styles.acrylicTeamAvtarItem}`}>
                                                                                <Avatar
                                                                                    className={`${styles.acrylicteamProfileAvtar}`}
                                                                                    src={ele?.image || ""}
                                                                                />
                                                                            </Grid>
                                                                            <Grid className={`${styles.acrylicTeamTitle}`}>
                                                                                <Typography component='span' sx={{ display: "inline-flex !important" }} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                                                    {`${capitalize(ele?.firstName) || ""} ${capitalize(ele?.lastName) || ""}`}
                                                                                </Typography>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>

                                                                    <Grid className={`${styles.acrylicTeamProfileTextItem}`}>
                                                                        <Grid container>
                                                                            <Grid size={{ xs: 12 }} sx={{ m: "3px 0px" }}>
                                                                                <Typography
                                                                                    component='span'
                                                                                    className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV12} ${styles.memberTitleText}`}
                                                                                >
                                                                                    {ele?.memberTitle || ""}
                                                                                </Typography>
                                                                            </Grid>
                                                                            <Grid size={{ xs: 12 }} sx={{ m: "3px 0px 0px" }}>
                                                                                <Typography component='span' sx={{ display: "inline-flex !important" }} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV13}`}>
                                                                                    {ele?.memberEmail || ""}
                                                                                </Typography>
                                                                            </Grid>
                                                                            <Grid size={{ xs: 12 }} sx={{ m: "3px 0px" }}>
                                                                                <Typography component='span' sx={{ display: "inline-flex !important" }} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV13}`}>
                                                                                    {ele?.memberPhone ? formatPhoneNumber(ele.memberPhone) : ""}
                                                                                </Typography>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </>
                                                    )
                                                }

                                                {!isLastItem && (
                                                    <Grid size={{ xs: 12 }} sx={{ m: "10px 0px" }}>
                                                        <Divider sx={{ borderColor: "#8B8B8B" }} />
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </Grid>
                                    );
                                })
                            ) : (
                                <Grid size={{ xs: 12 }} sx={{ textAlign: 'center', mt: 2 }}>
                                    <Typography variant="body1" sx={{ color: '#b9b3b3' }}>
                                        No Acrylic Team Data Found!
                                    </Typography>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default AcrylicTeamProfilelist